import React from 'react';

const LeafIcon = () => (
  <svg
    className="promise-icon"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M24 42C24 42 10 32 10 20C10 12.268 16.268 6 24 6C31.732 6 38 12.268 38 20C38 32 24 42 24 42Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M24 42V18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M24 24C20 22 16 20 14 16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M24 28C28 26 32 24 34 20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const DropletIcon = () => (
  <svg
    className="promise-icon"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M24 6C24 6 10 22 10 30C10 37.732 16.268 44 24 44C31.732 44 38 37.732 38 30C38 22 24 6 24 6Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M18 30C18 30 20 34 24 34"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const PawIcon = () => (
  <svg
    className="promise-icon"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <ellipse cx="16" cy="16" rx="4" ry="5.5" stroke="currentColor" strokeWidth="2" />
    <ellipse cx="32" cy="16" rx="4" ry="5.5" stroke="currentColor" strokeWidth="2" />
    <ellipse cx="10" cy="26" rx="3.5" ry="4.5" stroke="currentColor" strokeWidth="2" />
    <ellipse cx="38" cy="26" rx="3.5" ry="4.5" stroke="currentColor" strokeWidth="2" />
    <path
      d="M24 22C19 22 15 26 15 31C15 35.5 18.5 39 24 39C29.5 39 33 35.5 33 31C33 26 29 22 24 22Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

const PROMISES = [
  { label: 'No Preservatives', Icon: LeafIcon },
  { label: 'No Artificial Colors', Icon: DropletIcon },
  { label: 'No Animal Testing', Icon: PawIcon },
];

const PromiseBanner = () => (
  <section className="promise-banner" aria-label="Our Promise">
    <h2 className="promise-banner-title">
      <LeafIcon />
      Our Promise
    </h2>
    <div className="promise-banner-items">
      {PROMISES.map(({ label, Icon }) => (
        <div key={label} className="promise-banner-item">
          <Icon />
          <p className="promise-banner-text">{label}</p>
        </div>
      ))}
    </div>
  </section>
);

export default PromiseBanner;
